import type { UserDataRes, UserFavorites } from "@/types/user";
import { api } from "./axiosInstance";

export const apiGetUsedData = async (): Promise<UserDataRes> => {
  try {
    const response = await api.get(`/api/v1/users`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const apiUpdateFavorite = async ({
  favorite_locations, favorite_roles, favorite_reps, favorite_markets
}: UserFavorites): Promise<UserDataRes> => {
  const params = {
    favorite_locations,
    favorite_roles,
    favorite_reps,
    favorite_markets,
  };
  try {
    const response = await api.patch(`/api/v1/users`, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};
